export class SkimlinksService {
  private static readonly PUBLISHER_ID = process.env.REACT_APP_SKIMLINKS_ID;

  static convertToAffiliate(originalUrl: string): string {
    if (!this.PUBLISHER_ID) return originalUrl;

    try {
      const skimlinksUrl = `https://go.redirectingat.com?id=${this.PUBLISHER_ID}&url=${encodeURIComponent(originalUrl)}`;
      console.log('💰 Converting to affiliate link:', originalUrl);
      return skimlinksUrl;
    } catch (error) {
      console.error('Skimlinks conversion failed:', error);
      return originalUrl;
    }
  }

  static async trackClick(itemId: string, originalUrl: string, productTitle: string) {
    try {
      // Update click count in database
      const { supabase } = await import('./supabase');
      await supabase
        .from('wishlist_items')
        .update({ affiliate_clicks: supabase.rpc('increment_affiliate_clicks', { item_id: itemId }) })
        .eq('id', itemId);

      console.log('💰 Affiliate click tracked!', productTitle);
    } catch (error) {
      console.error('Click tracking failed:', error);
    }
  }
}
